import { Button } from "antd";

import { useModalState } from "@src/lib/ui-react";

import { CloneNfcTagsDialog, type CloneNfcTagsOriginWorkplace } from "./CloneNfcTagsDialog";

interface CloneNfcTagsButtonProps {
  origin: CloneNfcTagsOriginWorkplace;
  /**
   * Workplace `userId` to pre-select as the clone destination, typically the
   * source's `changeOfOwnership.replacementFacilityId`. The selector stays
   * editable.
   */
  defaultDestinationWorkplaceId?: string;
}

/**
 * Admin action for the facility drawer's "Change of Ownership" section. Clones
 * the current (source) workplace's active NFC tags into a destination workplace,
 * so the same physical posters keep working across a CHOW migration.
 */
export function CloneNfcTagsButton(props: CloneNfcTagsButtonProps) {
  const { origin, defaultDestinationWorkplaceId } = props;
  const modalState = useModalState();

  return (
    <>
      <Button
        type="default"
        onClick={() => {
          modalState.openModal();
        }}
      >
        Clone NFC tags
      </Button>
      {modalState.modalIsOpen && (
        <CloneNfcTagsDialog
          modalState={modalState}
          origin={origin}
          defaultDestinationWorkplaceId={defaultDestinationWorkplaceId}
        />
      )}
    </>
  );
}
